import { render } from "./OldStatements.vue?vue&type=template&id=70c235b7&scoped=true"
import script from "./OldStatements.vue?vue&type=script&lang=js"
export * from "./OldStatements.vue?vue&type=script&lang=js"

import "./OldStatements.vue?vue&type=style&index=0&id=70c235b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c235b7"]])

export default __exports__